import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar } from '@fortawesome/free-solid-svg-icons';
import { faClock } from '@fortawesome/free-regular-svg-icons';
import profilePic from '../../assets/wyzant_profile_pic.jpeg';


const Reviews = () => {
  return (
    <span className='flex items-center gap-1'>
      <FontAwesomeIcon icon={faStar} className='text-primary-light' size='sm'/>
      <FontAwesomeIcon icon={faStar} className='text-primary-light' size='sm'/>
      <FontAwesomeIcon icon={faStar} className='text-primary-light' size='sm'/>
      <FontAwesomeIcon icon={faStar} className='text-primary-light' size='sm'/>
      <FontAwesomeIcon icon={faStar} className='text-primary-light' size='sm'/>
      <span className='font-body text-sm text-neutral-400'> 5.0 (<a href='https://www.wyzant.com/match/tutor/88046130' className='text-primary-light hover:text-primary-foreground underline'>27 reviews</a>)</span>
    </span>
  );
};

const TutoringHours = () => {
  return (
    <div className='flex items-center gap-2 font-body text-sm text-neutral-400'>
      <FontAwesomeIcon icon={faClock} className='text-primary-light' /> 49 hours tutoring
    </div>
  );
}

const Testimonial = ({ content, author }) => {
  return (
    <div className='rounded-lg border border-neutral-800 bg-neutral-800 p-4 shadow-sm'>
      <p className='font-body text-sm text-neutral-300 leading-relaxed mb-3'>"{content}"</p>
      <p className='font-body text-sm text-primary-light text-right'>- {author}</p>
    </div>
  );
}

const Wyzant = () => {
  return (
    <div className="rounded-lg border border-neutral-800 bg-neutral-900 p-6 shadow-sm">
      <h2 className='font-heading text-2xl text-neutral-50 text-center mb-6'>Looking for Mentorship or Tutoring from Code Scribes?</h2>
      <div className='flex flex-col sm:flex-row gap-6 mb-6'>
        <img src={profilePic} alt='Derek Drummond a.k.a the Code Scribe' className='rounded-lg h-48 w-48 object-cover flex-shrink-0' />
        <div className='flex flex-col gap-3'>
          <p className='font-body text-sm text-neutral-300 leading-relaxed'>The first tenet of the Scribes Oath is giving back to the tech community. At Code Scribes we believe offering mentorship and tutoring is a powerful way to embody that principle. With 12+ years of industry experience, 5+ years of mentoring developers and having taught the University of Texas at Austin's Full-Stack Flex bootcamp places us at the intersection of academic excellence and cutting-edge technology. If you're looking to learn relevent skills that will help you advance your career in software development we can help.</p>
          <Reviews />
          <TutoringHours />
          <p className='font-body text-sm text-neutral-400'>Your first session is guaranteed by Wyzant's <a href='https://www.wyzant.com/faq/?faqId=6' className='text-primary-light hover:text-primary-foreground underline'>Good Fit Guarantee</a></p>
        </div>
      </div>
      <div className='mb-6'>
        <h3 className='font-heading text-xl text-primary-light mb-4'>Testimonials</h3>
        <div className='grid grid-cols-1 sm:grid-cols-3 gap-4'>
          <Testimonial content="Absolutely spot on! Take his help!!! Derek helped me simplify my app to whole other level of cleanliness. He's very attentive to syntax and will definitely spot any errors. His explanations were thoughtful, and to the point without arrogance or any sense of superiority. Looking forward to my next lesson where we'll be going over testing and learning even more." author='Steven A.' />
          <Testimonial content="Derek walked me through some ways to approach a python project I currently have and on how to think about test driven development. He wrote various live samples of code to help me understand the logic. Offered additional resources to help me continue learning and improve my beginner level coding skills" author='Jae M.' />
          <Testimonial content="Having Derek as a mentor gave me the confidence to jump feet first into programming. After a few sessions with Derek I felt confident I could find success as a software developer." author='Angel J.' />
        </div>
      </div>
      <div className='text-center'>
        <p className='font-body text-sm text-neutral-300 mb-3'>Book a session on <a href='https://www.wyzant.com' className='text-primary-light underline'>wyzant.com</a> with the Code Scribe himself.</p>
        <a href='https://www.wyzant.com/match/tutor/88046130/contact?onlineOnly=false'
          className='inline-flex items-center justify-center rounded-lg px-8 py-2.5 bg-primary text-sm font-body text-white shadow-sm transition-colors duration-150 hover:bg-primary-light focus:outline-none focus:ring-2 focus:ring-primary-light focus:ring-offset-2 focus:ring-offset-neutral-950'>
          Book Now
        </a>
      </div>
    </div>
  );
};

export default Wyzant;
